/*
 * Banner dismiss enhancement.
 *
 * Each <button data-banner-dismiss> inside a .banner removes its parent
 * banner on click. If the parent banner has a data-banner-id, the dismissed
 * state is recorded in sessionStorage so the same banner does not reappear
 * within the same session. sessionStorage (not localStorage) so we do not
 * need functional-cookie consent per CLAUDE Section 28.
 *
 * Implemented as document-level event delegation (no Custom Element class)
 * because there is nothing instance-scoped to manage. Self-contained.
 */
(function () {
  const STORAGE_PREFIX = 'bannerDismissed:';

  // Pre-hide banners already dismissed in this session
  function applyInitialState() {
    const banners = document.querySelectorAll('.banner[data-banner-id]');
    for (const banner of banners) {
      const id = banner.dataset.bannerId;
      if (id && sessionStorage.getItem(STORAGE_PREFIX + id) === '1') {
        banner.remove();
      }
    }
  }

  function onClick(event) {
    const btn = event.target.closest('[data-banner-dismiss]');
    if (!btn) return;
    const banner = btn.closest('.banner');
    if (!banner) return;
    const id = banner.dataset.bannerId;
    if (id) {
      try { sessionStorage.setItem(STORAGE_PREFIX + id, '1'); } catch (e) { /* sessionStorage may be blocked */ }
    }
    banner.remove();
  }

  document.addEventListener('DOMContentLoaded', applyInitialState);
  document.addEventListener('click', onClick);
})();
